import React from 'react';
// TODO: https://jira.moscow.alfaintra.net/browse/ALFABANKRU-83779
// eslint-disable-next-line package-imports/no-core-components-imports
import { PureCell } from '@alfalab/core-components-pure-cell';
import { IconViewCircle } from '@alfa-bank/site-icon-view/circle';

import { PseudoCheckbox } from '../pseudo-checkbox/pseudo-checkbox';
import type { TCashbackItem } from '../../models';

export const renderCashbackItem = ({
    isChecked,
    isLimitReached,
    item,
    showPseudoCheckbox,
}: TCashbackItem) => {
    const { imageLink, isEditable, name, percentRate } = item;

    return (
        <PureCell
            key={item.id}
            direction="horizontal"
            horizontalPadding="none"
            verticalPadding={showPseudoCheckbox ? 'compact' : 'default'}
        >
            <PureCell.Graphics>
                <IconViewCircle imageUrl={imageLink} size={48} />
            </PureCell.Graphics>
            <PureCell.Content>
                <PureCell.Main>
                    <PureCell.Text
                        titleColor="primary"
                        view="component-primary"
                    >{`${percentRate}% ${name}`}</PureCell.Text>
                </PureCell.Main>
                <PureCell.Addon verticalAlign="center">
                    {showPseudoCheckbox && (
                        <PseudoCheckbox
                            checked={isChecked}
                            disabled={!isEditable || (isLimitReached && !isChecked)}
                        />
                    )}
                </PureCell.Addon>
            </PureCell.Content>
        </PureCell>
    );
};
